"use strict"
exports.__esModule = true;
exports.SaveAltIconConfig = {
  name: 'SaveAltIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M1014.6,182.6 L841.4,9.4 C835.4,3.4 827.3,0 818.8,0 L32,0 C14.3,0 0,14.3 0,32 L0,992 C0,1009.7 14.3,1024 32,1024 L992,1024 C1009.7,1024 1024,1009.7 1024,992 L1024,205.3 C1024,196.8 1020.6,188.6 1014.6,182.6 Z M896,896 L128,896 L128,128 L779,128 L896,245 L896,896 Z M576,512 L576,271 C576,262.7 568.9,256 560.7,256 L466,256 C456.1,256 448,264.1 448,274 L448,512 L319.9,512 C292.8,512 278,543.5 295.2,564.4 L487.2,797 C500,812.5 523.9,812.5 536.6,796.9 L727.1,564.3 C744.2,543.4 729.3,512 702.3,512 L576,512 Z',
  yOffset: 0,
  xOffset: 0,
};
exports.SaveAltIcon = require('../createIcon').createIcon(exports.SaveAltIconConfig);
exports["default"] = exports.SaveAltIcon;